import { render, staticRenderFns } from "./MusicMenuFacebook.vue?vue&type=template&id=3c092d4e&scoped=true&"
import script from "./MusicMenuFacebook.vue?vue&type=script&lang=js&"
export * from "./MusicMenuFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c092d4e",
  null
  
)

export default component.exports